import type { Options } from '@splidejs/splide';

/** Parity with former Slick quote slider (dots on, no arrows, single slide). */
export const quoteSliderSplideOptions: Options = {
	type: 'slide',
	rewind: true,
	perPage: 1,
	perMove: 1,
	pagination: true,
	arrows: false,
	speed: 500,
	// Splide gives the root role="region" + aria-roledescription="carousel",
	// and a region with no name is a landmark you can't tell apart from any
	// other. Names the content, not the widget — the roledescription already
	// supplies "carousel", so "Quotes" is announced as "Quotes, carousel".
	label: 'Quotes',
};
